export default {
  setCookie (value) {
    let expires = ''
    let date = new Date()
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
    document.cookie = 'maicountrycode=' + value + expires + ';'
  },
  getCookie () {
    let nameEQ = 'maicountrycode='
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/store/helpers.js